"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const StyledDialog = exports.StyledDialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  zIndex: theme.zIndex.modal + 2
}));